import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Icons from "../../myIcon/Icons";

export default function LandingPageTwoBanner({ data , handleShow}) {

    return (
        <>
            <div className="landingtwo-banner-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-sm-10">
                            <div className="landingtwo-text">
                                <h1 className='heading'>
                                    {data.heading}
                                </h1>
                                <p>{data.description}</p>
                                <Link onClick={handleShow} className="default-btn">Book Free Design Consultation <Icons name="Longarrow_right"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={data.bannerImage} className="img-responsive" alt="banner" />  
            </div>
        </>
    )
}